/* global Vue */
import ReservationInput from './ReservationInput'
import { safeJsonParse, safeJsonArrayParse } from './utils'

export default function (selector) {
	const container = document.querySelector(selector)
	if (!container) return

	const attr = (name) => container.getAttribute(name)

	const app = new Vue({
		el: container,
		components: {
			ReservationInput
		},
		data () {
			const value = safeJsonParse(attr('data-value'), {})
			value.dateFromM = value.dateFrom
			value.option = Array.isArray(value.option) ? value.option : []
			return {
				props: {
					value,
					leaseTimeClasses: safeJsonArrayParse(attr('data-lease-time-classes')),
					availablePlans: safeJsonArrayParse(attr('data-available-plans')),
					options: safeJsonArrayParse(attr('data-options'))
				}
			}
		},
		template: `<ReservationInput v-bind="props">${container.innerHTML}</ReservationInput>`
	})
	return app
}
